import { MaskedText, Reveal, FadeIn } from "@/components/motion/Reveal";
import Reel from "@/components/Reel";
import { ABOUT, APPROACH } from "@/data/content";
import { img, HERO_VIDEO_ALT } from "@/data/media";

export default function About() {
  return (
    <>
      <section className="px-6 pb-20 pt-36 md:px-12 md:pt-48">
        <div className="mx-auto max-w-[1400px]">
          <FadeIn>
            <p className="overline mb-8 flex items-center gap-3 text-muted">
              <span className="h-px w-10 bg-clay" />
              About — Index 02
            </p>
          </FadeIn>
          <MaskedText
            lines={["Phaedra", "Paulson"]}
            className="font-display text-[12vw] font-extralight leading-[0.9] tracking-tight text-ink md:text-[8vw]"
          />
        </div>
      </section>

      <section className="px-6 pb-24 md:px-12 md:pb-40">
        <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <Reel {...HERO_VIDEO_ALT} ratio="aspect-[3/4]" label="Reel" reveal={false} />
            </Reveal>
            <div className="mt-8 grid grid-cols-2 gap-x-8 gap-y-6">
              {ABOUT.facts.map(([k, v]) => (
                <Reveal key={k} className="border-t border-hairline pt-3">
                  <p className="overline text-muted">{k}</p>
                  <p className="mt-1 font-body text-sm text-ink">{v}</p>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 lg:pl-12">
            {ABOUT.bio.map((para, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <p className={`font-display font-extralight tracking-tight leading-[1.28] ${i === 0 ? "text-2xl text-ink md:text-3xl" : "mt-8 text-xl text-stone md:text-2xl"}`}>
                  {para}
                </p>
              </Reveal>
            ))}

            <div className="mt-20 space-y-10">
              {APPROACH.map((item, i) => (
                <Reveal key={item.no} delay={i * 0.05} className="flex gap-6 border-t border-hairline pt-6">
                  <span className="font-mono text-sm text-clay">{item.no}</span>
                  <div>
                    <h2 className="font-display text-xl font-extralight tracking-tight text-ink md:text-2xl">{item.title}</h2>
                    <p className="mt-3 max-w-lg font-body text-sm leading-relaxed text-stone">{item.body}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="border-t border-hairline px-6 py-24 md:px-12">
        <div className="mx-auto grid max-w-[1400px] grid-cols-2 gap-6 md:grid-cols-4 md:gap-10">
          {[82, 66, 90, 84].map((n, i) => (
            <Reveal key={n} delay={i * 0.06} className={i % 2 === 1 ? "md:mt-14" : ""}>
              <div className="group relative aspect-[3/4] overflow-hidden bg-paper2">
                <img src={img(n)} alt="Work" className="hover-media h-full w-full object-cover" />
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
